import { ReactElement } from 'react';
import { RouteData } from '@sitecore-jss/sitecore-jss-nextjs';

import { getComponentProps } from '../../getters';
import { SearchMenuFields } from '../../types';
import { LanguageSelector, LanguageSelectorProps } from '../LanguageSelector/LanguageSelector';
import { LanguageSelectorButton } from '../LanguageSelector/LanguageSelectorButton';
import { SearchButton } from '../Search';
import { Search } from '../Search/components/Search';
import { SubmenuId } from './MegaMenuTypes';

export enum HeaderComponentName {
  Search = 'Search',
  LanguageSelector = 'LanguageSelector',
}

export const submenuComponentsMap: Record<
  SubmenuId | string,
  (route: RouteData) => ReactElement | null
> = {
  SiteSelector: (route) => {
    const languageRenderingFields = getComponentProps(
      route.placeholders,
      HeaderComponentName.LanguageSelector
    )?.fields as unknown as LanguageSelectorProps['fields'];

    return <LanguageSelector fields={languageRenderingFields} />;
  },
  Search: (route) => {
    const searchFields = getComponentProps(route.placeholders, HeaderComponentName.Search)
      ?.fields as SearchMenuFields;

    return <Search fields={searchFields} isDropdown />;
  },
};

export const menuComponentsMap: Record<
  SubmenuId,
  (onClick: () => void, isActive?: boolean) => ReactElement
> = {
  SiteSelector: (onClick, isActive) => {
    return <LanguageSelectorButton onClick={onClick} isActive={isActive} />;
  },
  Search: (onClick, isActive) => {
    return <SearchButton onClick={onClick} isActive={isActive} />;
  },
};
